const sortOrder = (chip) => chip.id;
const onChipClick = () => {};
const onApplyFilter = () => {};

export default {
  sortOrder,
  onChipClick,
  onApplyFilter,
};
